import 'slick.min.js'
import 'jquery.countTo.js'
import 'jquery.maskedinput.js'
import 'jquery.validate.js'

import '@chenfengyuan/datepicker/dist/datepicker';
import '@chenfengyuan/datepicker/i18n/datepicker.ru-RU';

import url from 'url';

const queryParser = require('query-string');

$(document).ready(function () {
  ticker();

  // Валидация формы
  $('.form_block').validate({
    rules: {
      name: {
        required: true,
      },
      date_of_birth: {
        required: true,
        minlength: 6,
        regex: '^[0-9]{2}\.[0-9]{2}\.[0-9]{4}$'
      },
      email: {
        required: true,
        minlength: 5,
        email: true

      },
      phone: {
        required: true,
        minlength: 12
      }
    },
    messages: {
      name: 'Введите имя',
      date_of_birth: 'Введите корректную дату рождения',
      email: 'Введите валидный e-mail адрес',
      phone: 'Введите валидный номер телефона'
    }
  });
  $.validator.addMethod(
    "regex",
    function (value, element, regexp) {
      var re = new RegExp(regexp);
      return this.optional(element) || re.test(value);
    },
    "Проверьте корректность данных."
  );

  // Включение лоадера при сабмите формы
  $('.form_block').submit(function (e) {
    // Форматируем телефон перед отправкой - убираем маску и оставляем только цифры без +7
    const phoneInput = $('.phone_input');
    const phoneValue = phoneInput.val();
    const formattedPhone = phoneValue.replace(/\D/g, '').slice(1); // Убираем все не-цифры и удаляем первую цифру (+7)
    
    // Удаляем только скрытые поля телефона (которые мы сами создали)
    $(this).find('input[type="hidden"][name="registration_request[phone]"]').remove();
    
    // Создаем скрытое поле с отформатированным телефоном
    const hiddenPhoneField = $('<input>').attr({
      type: 'hidden',
      name: 'registration_request[phone]',
      value: formattedPhone
    });
    
    // Удаляем атрибут name у оригинального поля телефона и добавляем новое скрытое поле
    phoneInput.removeAttr('name');
    $(this).append(hiddenPhoneField);
    
    $('#overlay_preloader').removeClass('d_none')
  });

  // Обзервер который проверяет появился ли попап после отправки формы,
  // если да, значит запрос завершен и отключаем лоадер
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'style') {
        $('#overlay_preloader').addClass('d_none')
      }
    });
  });
  const config = { attributes: true };
  observer.observe($('.popup')[0], config);

  // Проверка заполнен ли инпут email и соответственная смена показа иконки
  $('.email_input').on('input', function () {
    const value = $('.email_input').val();
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    $('.validate_email_icon_checked').toggleClass('d_none', !emailRegex.test(value));
    $('.validate_email_icon_unchecked').toggleClass('d_none', emailRegex.test(value));
  });

  // Проверка заполнен ли инпут phone и соответственная смена показа иконки
  $('.phone_input').on('keyup', function () {
    const value = $('.phone_input').mask();
    const phoneRegex = /^\d{10}$/;

    $('.validate_phone_icon_checked').toggleClass('d_none', !phoneRegex.test(value));
    $('.validate_phone_icon_unchecked').toggleClass('d_none', phoneRegex.test(value));
  })


  $('.date_input').datepicker({
    calendarWeeks: true,
    todayHighlight: true,
    language: 'ru-RU'
  });

  // Обработчик слайдера
  const $slider = $('.slider_wrapper');
  const $slides = $('.slider_item');
  const $menuItems = $('.slider_menu_item');

  $slider.on('scroll', function () {
    const scrollPosition = $slider.scrollLeft();

    $slides.each(function (index) {
      const slideOffsetLeft = $(this).offset().left;
      const slideWidth = $(this).width();

      if (scrollPosition >= slideOffsetLeft && scrollPosition < slideOffsetLeft + slideWidth) {
        $menuItems.removeClass('active');
        $menuItems.eq(index).addClass('active');
      }
    });
  });

  // Обработчик акордеона
  $('.accordion_header').click(function () {
    var accordionItem = $(this).parent('.accordion-item');
    var accordionContent = $(this).siblings('.content');

    // Проверяем, открыт ли текущий пункт аккордеона
    if (accordionItem.hasClass('active')) {
      // Если пункт аккордеона уже открыт, скрываем его содержимое и показываем заголовок
      accordionContent.slideUp();
      accordionItem.removeClass('active');
      $(this).show();
    } else {
      // Если пункт аккордеона закрыт, скрываем содержимое всех пунктов и показываем заголовки
      $('.content').slideUp();
      $('.accordion-item').removeClass('active');
      $('.accordion_header').show();

      // Показываем содержимое текущего пункта и скрываем его заголовок
      accordionContent.slideDown();
      accordionItem.addClass('active');
      $(this).hide();
    }
  });

  $(".phone_input").mask("+7 (999) 999 99 99");

  $('.date_input').datepicker({
    calendarWeeks: true,
    todayHighlight: true,
    language: 'ru-RU'
  });

  // Раскрытие/Закрытие сайдбара
  $(".burger_menu").click(function () {
    $("#overlay_sidebar").removeClass('d_none')
  })
  $(".sidebar_close_button, .overlay").click(function () {
    $("#overlay_sidebar").addClass('d_none')
  })
  $(".sidebar").click(function (e) {
    e.stopPropagation()
  })

  // Если есть селектор id главной страницы, то проводим обработку урла
  if ($('#home_page').length > 0) {
    // Получаем текущий урл
    const parsedUrl = url.parse(window.location.href)
    // Парсим query-параметры из урла
    const parsedQuery = queryParser.parse(parsedUrl.query)

    // Если query-параметры есть и среди них есть параметры hash и id,
    // то пробуем отправить запрос на подтверждение учетной записи
    if (Object.keys(parsedQuery).length > 0 && parsedQuery.hash && parsedQuery.id) {
      $.ajax({
        url: 'registration_requests/' + parsedQuery.id + '/confirm/' + parsedQuery.hash,
        type: 'PATCH',
        data: {}
      });
    }
  }
  if(location.hash == '#confirm-success'){
    $.fancybox.open( $('#confirm-success'), {
       touch: false
    });
  }

  if(location.hash == '#confirm-error'){
    $.fancybox.open( $('#confirm-error'), {
      touch: false
    });
  }

  if(location.hash == '#subscribe-success'){
    $.fancybox.open( $('#info-popup'), {
      touch: false
    });
  }
});

// Бесконечная бегущая строка
function ticker() {
  // Строка справа налево
  const tickerElement = document.querySelector('.ticker');
  const tickerAddress = document.querySelector('.address_ticker');
  const tickerAddressClone = tickerAddress.cloneNode(true);

  tickerElement.append(tickerAddressClone);
}
